import './App.css';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Course from './pages/Course/Course';
import Home from './pages/Home/Home';

import {Route,Routes} from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/course" element={<Course/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
    </div>
  );
}

export default App;
